import { render, staticRenderFns } from "./form13.vue?vue&type=template&id=38a9eafc&scoped=true"
import script from "./form13.vue?vue&type=script&lang=js"
export * from "./form13.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a9eafc",
  null
  
)

export default component.exports